import { PlateContext } from "../../../store/GenreContext";
import classes from "./Plates2.module.css";
import PlatesInner from "./PlatesInner";
import React, { useContext, useEffect } from "react";

const Plates = ({ language, category, index, groupArr, plates }) => {
  const { isLoading } = useContext(PlateContext);

  const languagePosition = language?.split("/")?.[2];



  return (
    <section>
      {isLoading ? (
        <div className={classes.spinner}></div>
      ) : plates?.length > 0 ? (
        <>
          <div
            className={`${classes.flexCat} ${
              languagePosition === "rtl" ? classes.rightToLeft : ""
            }`}
          >
            <div className={classes.category}>
              {category.label.toUpperCase()}
            </div>
          </div>

          {plates.map((plate, idx) => (
            <PlatesInner
              key={plate.id || idx}
              languagePosition={languagePosition}
              language={language}
              plate={plate}
            />
          ))}

          {index === groupArr.length - 1 || groupArr[index + 1]?.[1]?.length === 0 ? (
            <hr className={classes.end} />
          ) : (
            <hr className={classes.hrCategory} />
          )}
        </>
      ) : null}
    </section>
  );
};

export default Plates;
